import { jsx as _jsx } from "react/jsx-runtime";
import { VolunteerServiceProvider } from '../../volunteer-service/rest/VolunteerServiceProvider';
import PhraseProvider from '../../phrase/PhraseProvider';
import RegisterVolunteer from './RegisterVolunteer';
function App({ volunteerApiUri, labels }) {
    return (_jsx(PhraseProvider, Object.assign({ phrases: labels !== null && labels !== void 0 ? labels : {} }, { children: _jsx(VolunteerServiceProvider, Object.assign({ uri: volunteerApiUri }, { children: _jsx("div", Object.assign({ className: "volunteer-form-app" }, { children: _jsx(RegisterVolunteer, {}) })) })) })));
}
export default App;
